import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 13h8v2H3zm0 4h8v2H3zm0-8h8v2H3zm0-4h8v2H3zm16 2v10h-4V7h4m2-2h-8v14h8V5z"
}), 'VerticalSplitOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VerticalSplitOutlined.js
// module id = 7026
// module chunks = 2